module.exports = __webpack_public_path__ + "30fc1b5c6756dcdb4b5f10c26bb233f7.svg";